import React, {useEffect} from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import useFetchLibraryFolders from '../../../../hooks/useFetchLibrary'
import LoadingSpinner from '../../../../components/loading-spinner'
import {contentStyle} from './index.style'
import PageNotFound from '../../../../pages/page-not-found'

function TeamCavenders() {
    const {
        data: {page_title, page_description, page_keywords, c_body = ''},
        loading,
        error
    } = useFetchLibraryFolders(`content/team-cavenders`)

    useEffect(() => {
        if (!c_body || !location.hash) return

        const timer = setTimeout(() => {
            const anchor =
                document.getElementById(location.hash.slice(1)) ||
                document.querySelector(`a[name="${location.hash.slice(1)}"]`)

            if (!anchor) return

            anchor.classList.add('anchor-target')
            anchor.scrollIntoView({block: 'start'})
        }, 600)

        return () => clearTimeout(timer)
    }, [c_body])

    if (loading && !error) {
        return <LoadingSpinner />
    }
    if (error || !c_body) {
        // Display PageNotFound if there's an error or no content body
        return <PageNotFound />
    }

    return (
        <Box sx={contentStyle}>
            <Seo title={page_title} description={page_description} keywords={page_keywords} />
            <Box dangerouslySetInnerHTML={{__html: c_body}} />
        </Box>
    )
}

export default TeamCavenders
